<template>
  <div
    v-if="letter.id"
  >
    <div
      class="row"
    >
      <div class="col-md-10">
        <b-card
          no-body
        >
          <div class="m-2">
            <div class="row">
              <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>{{ $t('Code') }}</th>
                    <td> {{ letter.code }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('From') }}</th>
                    <td> {{ $langName(letter.from_org.name) }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('To') }}</th>
                    <td> {{ letter.to_org.name[$i18n.locale] }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('Short Info') }}</th>
                    <td> {{ letter.short_info }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>{{ $t('Status') }}</th>
                    <td>
                      <b-badge :variant="getLetterStatusColor(letter.letter_status)">
                        {{ $langName(getLetterStatus(letter.letter_status).name) }}
                      </b-badge>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('Letter Type') }}</th>
                    <td> {{ getLetterType(letter.letter_type).name[$i18n.locale] }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('Period') }}</th>
                    <td> {{ letter.period.name }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('Rejected Info') }}</th>
                    <td> {{ letter.reject_info }}</td>
                  </tr>
                  <tr v-if="isTargeted() && letter.reason_file">
                    <th>{{ $t('App') }}</th>
                    <td> <b-link
                      :href="letter.reason_file"
                      download="file"
                      target="_blank"
                    >
                      <feather-icon
                        icon="DownloadIcon"
                        class="mr-50"
                      />
                      <span>{{ $t('Download') }}</span>
                    </b-link> </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card
          no-body
        >
          <div class="m-2">
            <b-button
              v-if="canCreateQuote(letter)"
              v-b-toggle.sidebar-create-quote
              variant="success"
              class="btn mb-75 btn-primary btn-block collapsed"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              <span>{{ $t('Create') }}</span>
            </b-button>

            <b-button
              v-if="canSend(letter)"
              v-b-toggle.sidebar-send-letter
              variant="primary"
              class="btn btn-primary btn-block collapsed"
            >
              <feather-icon
                icon="SendIcon"
                class="mr-50"
              />
              <span>{{ $t('Send') }}</span>
            </b-button>
            <b-link
              v-if="canDownloadFile(letter)"
              :href="letter.letter_file"
              class="btn btn-warning btn-block collapsed"
              download="file"
              target="_blank"
            >
              <feather-icon
                icon="DownloadIcon"
                class="mr-50"
              />
              <span>{{ $t('Download') }}</span>
            </b-link>

            <b-button
              v-if="canRegenerate(letter)"
              variant="primary"
              class="btn btn-primary btn-block collapsed"
              @click="regenerate"
            >
              <span>{{ $t('Regenerate Letter') }}</span>
            </b-button>
          </div>
        </b-card>
      </div>
    </div>
    <div v-if="canShowQuoteTable(letter)">
      <h3 class="text-center">
        {{ $t("General request quota table") }}
      </h3>
      <quote
        ref="quote"
        @refetchData="refetchData"
      />
    </div>
    <send
      ref="send"
      @refetchData="refetchData"
    />
    <accepted
      v-if="!isTargeted()"
      ref="accepted"
    />
  </div>

</template>

<script>
import {
  BButton, BCard, VBToggle, BBadge, BLink,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Send from './Send.vue'
import letterModule from '@/store/letter/index'
import store from '@/store'
import Quote from './quote/Quote.vue'
import Accepted from './Accepted/Accepted.vue'
import permission from './permission'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BButton,
    Quote,
    Send,
    BBadge,
    Accepted,
    BLink,
  },
  computed: {
    letter() {
      return this.$store.state[this.MODULE_NAME].letter
    },
  },
  created() {
    this.refetchData()
    this.$store.dispatch('staticModule/letterTypes')
    this.$store.dispatch('staticModule/letterStatuses')
  },
  methods: {
    getLetterType(id) {
      return this.$store.getters['staticModule/getLetterType'](id)
    },
    isTargeted() {
      return (this.letter.letter_type === this.$store.state.staticModule.letterTypeTargeted)
    },
    getLetterStatus(id) {
      return this.$store.getters['staticModule/getLetterStatus'](id)
    },
    getLetterStatusColor(id) {
      return this.$store.getters['staticModule/getLetterStatusColor'](id)
    },
    refetchData() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id).then(() => {
        if (this.$refs.quote) {
          this.$refs.quote.refetchData()
        }
      })
    },
    regenerate() {
      this.$removeSwal(
        this,
        { letter_id: this.letter.id },
        'letter/regenerateLetter',
        res => {
          this.$router.push({ name: 'letter-view', params: { id: res } })
          this.refetchData()
        },
        {
          confirmButtonText: 'Yes, regenerate it!',
          successTitle: 'Regenerated!',
          successText: 'Your letter has been regenerated.',
          errorText: 'Your letter has not been regenerated.',
        },
      )
    },
  },
  setup() {
    const MODULE_NAME = 'letter'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, letterModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
      ...permission(),
    }
  },
}
</script>
